const CHUNK_RELOAD_KEY = "qenqo_chunk_reload_attempted";

export function isChunkLoadError(error) {
  const name = String(error?.name || "");
  const message = String(error?.message || "");
  return (
    name === "ChunkLoadError"
    || /Loading chunk \d+ failed/i.test(message)
    || /Loading CSS chunk \d+ failed/i.test(message)
    || /dynamically imported module/i.test(message)
  );
}

export function reloadOnceForChunkError() {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === "1") return false;
  sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
  window.location.reload();
  return true;
}

export function clearChunkReloadMarker() {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
}

export function installChunkLoadRecovery() {
  window.addEventListener("load", () => {
    window.setTimeout(clearChunkReloadMarker, 1500);
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (isChunkLoadError(event.reason)) {
      reloadOnceForChunkError();
    }
  });
}
